// extracted by mini-css-extract-plugin
export default {"bgConfetti":"ModalInsigniaObtenida_bgConfetti__2BzQb","bgStars":"ModalInsigniaObtenida_bgStars__dnsHR","insigniaModal":"ModalInsigniaObtenida_insigniaModal__XWY3F"};